import './page_and_template_status.less';

import React, { Fragment } from 'react';
import classNames from 'classnames';

import { SafeTipsy } from 'zoomforth_component_lib/tipsy.jsx';
import { WarningIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

const PageAndTemplateStatusUI = ({
  description,
  icon,
  isActive,
  style,
  secondaryDescription,
  tooltip
})=> (
  <SafeTipsy content={tooltip}>
    <span
      style={style}
      className={classNames('page-and-template-status', {
        'is-active': isActive,
        'has-primary-status-icon': !!icon
      })}
    >

      {
        icon &&
          <span className="status-color">
            {icon}
          </span>
      }

      <span className="status-message">
        {description}

        {
          !!secondaryDescription &&
            <Fragment>
              <WarningIcon className="requires-attention-icon" /> {secondaryDescription}
            </Fragment>
        }
      </span>

    </span>
  </SafeTipsy>
);

export default PageAndTemplateStatusUI;
